import { QueryClient } from '@tanstack/react-query';
import { regionsQueries } from '@/queries/regions';

export const regionByIdLoader = (queryClient: QueryClient) => (regionId: string) => {
  return queryClient.fetchQuery(regionsQueries.item(regionId));
};
